import {
  Box,
  Button,
  MenuItem,
  Select,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  SelectChangeEvent,
} from '@mui/material';
import { useState } from 'react';

interface CarFormData {
  brand: string;
  model: string;
  year: string;
  pcd: string;
  dia: string;
  et: string;
  width: string;
  diameter: string;
}

const AddCarsPage = () => {
  const [formData, setFormData] = useState<CarFormData>({
    brand: '',
    model: '',
    year: '',
    pcd: '',
    dia: '',
    et: '',
    width: '',
    diameter: '',
  });

  const brands = ['Toyota', 'BMW', 'Mercedes', 'Hyundai'];

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelectChange = (e: SelectChangeEvent) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // console.log('Добавлено авто:', formData);
  };

  return (
    <Box maxWidth={600} mx="auto" mt={4}>
      <Typography variant="h5" mb={3}>
        Добавить автомобиль
      </Typography>
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal">
          <InputLabel>Марка</InputLabel>
          <Select
            name="brand"
            value={formData.brand}
            onChange={handleSelectChange}
            label="Марка"
            required
          >
            {brands.map(brand => (
              <MenuItem key={brand} value={brand}>
                {brand}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          name="model"
          label="Модель"
          fullWidth
          margin="normal"
          value={formData.model}
          onChange={handleChange}
          required
        />

        <TextField
          name="year"
          label="Год"
          type="number"
          fullWidth
          margin="normal"
          value={formData.year}
          onChange={handleChange}
          required
        />

        <TextField
          name="pcd"
          label="PCD"
          fullWidth
          margin="normal"
          value={formData.pcd}
          onChange={handleChange}
        />

        <TextField
          name="dia"
          label="DIA"
          fullWidth
          margin="normal"
          value={formData.dia}
          onChange={handleChange}
        />

        <TextField
          name="et"
          label="ET"
          fullWidth
          margin="normal"
          value={formData.et}
          onChange={handleChange}
        />

        <TextField
          name="width"
          label="Ширина"
          fullWidth
          margin="normal"
          value={formData.width}
          onChange={handleChange}
        />

        <TextField
          name="diameter"
          label="Диаметр"
          fullWidth
          margin="normal"
          value={formData.diameter}
          onChange={handleChange}
        />

        <Button type="submit" variant="contained" sx={{ mt: 3 }}>
          Добавить
        </Button>
      </form>
    </Box>
  );
};

export default AddCarsPage;
